import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";

const IS_WORKFLOW_CONFIG_MANAGER_QUERY = gql(`
  query IsWorkflowConfigManager {
    isWorkflowConfigManager
  }
`);

export function useWorkflowConfigAuth() {
  const { data, loading } = useQuery(IS_WORKFLOW_CONFIG_MANAGER_QUERY);

  return {
    isAuthorized: data?.isWorkflowConfigManager ?? false,
    loading,
  };
}

